import { UpdateTotalWinMeterActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { WinSequencePresenter } from "./WinSequencePresenter";

/**
 * `update_total_win_meter` → the win labels fly into the title's meter, which takes the spin's running total; a
 * feature exit hides the meter (the finished panel and the bar's current win take the round's total over). Listed
 * before the current-win plugin, so the hide precedes the park on exit (decision 46).
 */
export function createWinCollectPlugin(deps: { presenter: WinSequencePresenter }): ReplayPlugin {
  return {
    name: "win-meter",
    actionHandlers: [new UpdateTotalWinMeterActionHandler((amount) => deps.presenter.presentTotalWinAmount(amount))],
    observer: {
      onFeatureState: async (event) => {
        if (event.eventContent.featureState?.featurePhase === "exit") deps.presenter.hideWinMeterForNewSpin();
      },
    },
  };
}
